import { EscPosEncoder } from "./escposHelper";

export function htmlToEscpos(html) {

    const parser = new DOMParser();

    const doc = parser.parseFromString(html, "text/html");

    const encoder = new EscPosEncoder();

    encoder.reset();

    function walk(node) {

        if (node.nodeType === Node.TEXT_NODE) {

            encoder.text(node.textContent);

        } else if (node.nodeType === Node.ELEMENT_NODE) {

            switch (node.tagName.toLowerCase()) {

                case "b":

                case "strong":

                    encoder.bold(true);

                    node.childNodes.forEach(walk);

                    encoder.bold(false);

                    break;

                case "center":

                    encoder.align("center");

                    node.childNodes.forEach(walk);

                    encoder.align("left");

                    break;

                case "p":

                    node.childNodes.forEach(walk);

                    encoder.newline();

                    break;

                case "br":

                    encoder.newline();

                    break;

                case "hr":

                    encoder.newline().text("------------------------------").newline();

                    break;

                default:

                    node.childNodes.forEach(walk);

            }

        }

    }

    doc.body.childNodes.forEach(walk);

    encoder.feed(3).cut();

    return encoder.encode();

}